import Logger from '../../../server/src/logger';
import { resource } from './resource';

const isDefined = value => typeof value !== 'undefined';

export const api = (dispatch, action) => {
  const {
    onSuccess,
    onFailure,
    onApiStart,
    onApiEnd,
    ...restProps
  } = action.payload;

  const request = resource(restProps);

  if (isDefined(onApiStart)) {
    dispatch(onApiStart());
  }

  return request
    .then(response => {
      if (
        isDefined(onFailure) &&
        !response.status.toString().startsWith('20')
      ) {
        const failureAction = onFailure(`HTTP status code ${response.status}`);

        if (failureAction) {
          return dispatch(failureAction);
        }
      }

      return dispatch(onSuccess(response.data, response));
    })
    .catch(error => {
      if (isDefined(onFailure)) {
        const failureAction = onFailure(error);

        if (failureAction) {
          return dispatch(failureAction);
        }
      }

      Logger.warn(`Failed to perform query ${error}`);
    });
};
